import React, { createContext, useContext, useState, useEffect } from "react";

export const CSSVariablesContext = createContext({});

export const CSSVariablesProvider = ({ url, children }) => {
  const [variables, setVariables] = useState({});

  useEffect(
    () => {
      fetch(url)
        .then(response => response.text())
        .then(content => {
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = content;

          // Insere os estilos antes do primeiro link existente
          const firstStyleElement = document.head.querySelector("link");
          const styleTag = tempDiv.querySelector("style");

          if (styleTag) {
            // Insere o style antes do primeiro link
            document.head.insertBefore(styleTag, firstStyleElement);

            // Processa as variáveis CSS
            const rootContent = styleTag.textContent.match(/:root\s*{([^}]*)}/);
            if (rootContent && rootContent[1]) {
              const vars = {};
              const declarations = rootContent[1].split(";");

              declarations.forEach(declaration => {
                const [key, value] = declaration
                  .split(":")
                  .map(item => item.trim());
                if (key && key.startsWith("--")) {
                  vars[key] = value || "";
                }
              });

              setVariables(vars);
            }
          }

          // const linkTags = tempDiv.querySelectorAll('link[rel="stylesheet"]');
          // linkTags.forEach(linkTag => {
          //   document.head.insertBefore(linkTag, firstStyleElement);
          // });
        })
        .catch(error => console.error("Erro ao carregar CSS:", error));
    },
    [url]
  );

  return (
    <CSSVariablesContext.Provider value={variables}>
      {children}
    </CSSVariablesContext.Provider>
  );
};

export const useCSSVariables = () => useContext(CSSVariablesContext);
